import React from 'react';
import * as css from './SendingTabs.css';
import SendingTabItem from './SendingTabItem';

function SendingTabs({currentTab, onTabClick, whatsappAllowed}: {currentTab: string, onTabClick: (tab: string) => void, whatsappAllowed: boolean}) {
    const tabsList = [
        ...(whatsappAllowed ? [{key: 'whatsapp', text: 'whatsapp', type: 'whatsapp'}] : []),
        {key: 'email', text: 'email', type: 'email'},
        {key: 'sms', text: 'sms', type: 'sms'}
    ];

    const handleTabClick = (tab) => {
        if(tab.disabled) return;
        onTabClick(tab.key);
    };

    return (
        <css.tabsContainer>
            <css.tabsMenu>
                {tabsList.map((tab) => (
                    <SendingTabItem
                        key={tab.key}
                        tab={tab}
                        currentTab={currentTab}
                        onTabClick={handleTabClick}
                    />
                ))}
            </css.tabsMenu>
        </css.tabsContainer>
    );
}

export default SendingTabs;
